const initialValues = {
  Diagnoses: {
    DiagnosisID: undefined,
    DoctorNotes: "",
  },
  PrescribedEquipments: [
    {
      Code: undefined,
      Duration: undefined,
      Notes: "",
    },
  ],
  PrescribedMedications: [
    {
      Code: undefined,
      Dose: "",
      Duration: undefined,
    },
  ],
  PrescriptionImage: "",
  AppointmentID: undefined,
};

export default initialValues;
